<template>
  <div class="step-container scrollPosition haus-step-9">
    <div class="step-header">
      <h2 class="step-title">Verwendungszweck</h2>
      <p class="step-text">Wofür benötigen Sie den Immobiliencheck?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Kauf"
          @click="setVerwendung('KAUF')"
          :iconDefault="require('@/assets/icons/Svgs/Vereinigungsmenge_70.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Vereinigungsmenge_70_white.svg')
          "
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Verkauf"
          @click="setVerwendung('VERKAUF')"
          :iconDefault="require('@/assets/icons/Svgs/Vereinigungsmenge_69.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Vereinigungsmenge_69_white.svg')
          "
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Bestandsimmobilie"
          @click="setVerwendung('BESTAND')"
          :iconDefault="require('@/assets/icons/Svgs/Vereinigungsmenge_71.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Vereinigungsmenge_71_white.svg')
          "
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { getFromStorage,
  isSet,
  // isSet,
   saveToStorage } from "@/utils.js";
export default {
  name: "haus-step-9",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        f_zweck: { value: null },
      },
      readonly: {
        flagKeller: { value: null },
      },
    };
  },
  methods: {
    setVerwendung(f_zweck) {
      this.fields.f_zweck.value = f_zweck;
      saveToStorage(this.fields);
      this.$router.push("/haus-step-10");
    },
    goBack() {
      // this.$router.push("/haus-step-8");
      if (
        isSet(this.readonly.flagKeller.value)
      ) {
        this.$router.push("/haus-step-8b");
      } else {
        this.$router.push("/haus-step-8a");
      }
    },
  },
  mounted() {
    this.$emit("setStep", "haus", 11);
    getFromStorage(this.readonly);
  },
};
</script>
<style scoped>
.box-item {
  flex-basis: 250px;
  height: 200px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    grid-auto-rows: minmax(150px, auto);
  }
  .box-item {
    height: 100%;
  }
}
</style>
